import { render, staticRenderFns } from "./sample-code.vue?vue&type=template&id=5bdd16d1"
import script from "./sample-code.vue?vue&type=script&lang=js"
export * from "./sample-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports